import { TILE_LIBRARY_TYPES } from 'state/map/tiles/constants';
import TileRects from './TileRects';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: TileRects,
  [TILE_LIBRARY_TYPES.JSLA]: TileRects,
};
